export default __webpack_public_path__ + "locales/sr-Latn-RS/FormGallery.json?hash=f1100894001a0447d62bf49671a5f7a3";